import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class TecnicasService {

  constructor(private http: HttpClient) {}
  getTecnicas(){
    return this.http.get("assets/data/tecnicas.json")
  }
}
